var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { Loader, Navbar } from './components';
import { AppContext } from './hooks/context';
import { useHttp } from './hooks/useHttp';
import Router from './pages';
const App = () => {
    const { request } = useHttp();
    const [mainLoader, setMainLoader] = React.useState(true);
    const [user, setUser] = React.useState({
        id_AVN_user: null,
        AVN_login: null,
        name: null,
        patronymic: null,
        surname: null,
        access: false,
        visible: false,
    });
    const [login, setLogin] = React.useState(null);
    const [auth, setAuth] = React.useState({
        id_user: null,
        id_role: null,
        id_avn_user: null,
        isAuth: false,
    });
    const getInfoUser = () => __awaiter(void 0, void 0, void 0, function* () {
        const { data } = yield request(`/user/${auth.id_avn_user}`);
        const resCheckAccess = yield request(`/access?AVN_login=${data.AVN_login}`);
        setLogin(data.AVN_login);
        setUser({
            id_AVN_user: data.id_AVN_user,
            access: resCheckAccess.data.canRemoveDFSFromExStudent,
            AVN_login: data.AVN_login,
            surname: data.surname,
            name: data.name,
            patronymic: data.patronymic,
            visible: resCheckAccess.data.visible,
        });
    });
    const checkAuth = () => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield request('/auth/check');
        const { data, auth, type, message } = res;
        setMainLoader(false);
        toast[type](message);
        if (res.auth) {
            setAuth({
                isAuth: auth,
                id_user: data.id_user,
                id_avn_user: data.id_avn_user,
                id_role: data.id_role,
            });
        }
    });
    const isUp = () => {
        const up = document.querySelector('.up_');
        window.addEventListener('scroll', () => {
            if (window.scrollY < 100) {
                return (up.style.display = 'none');
            }
            up.style.display = 'flex';
        });
    };
    const up = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };
    React.useEffect(() => {
        checkAuth();
    }, []);
    React.useEffect(() => {
        if (auth.isAuth) {
            getInfoUser();
            isUp();
        }
    }, [auth]);
    if (mainLoader) {
        return (_jsx("div", Object.assign({ className: "d-flex justify-content-center align-items-center", style: { height: '100vh' } }, { children: _jsx(Loader, { type: "text-primary" }) })));
    }
    return (_jsxs(AppContext.Provider, Object.assign({ value: { setAuth, user, auth, login } }, { children: [_jsx(ToastContainer, {}), auth.isAuth && (_jsx("div", Object.assign({ onClick: up, className: "text-bg-primary bg-primary position-fixed up_" }, { children: _jsx("i", { className: "fa-solid fa-arrow-up", style: { fontSize: '24px' } }) }))), _jsx(Navbar, { name: user.name, surname: user.surname, auth: auth.isAuth, setUser: setUser, setAuth: setAuth }), _jsx(Router, { auth: auth.isAuth })] })));
};
export default App;
